import { Component, OnInit } from '@angular/core';
import { ScaffoldDialogRef } from '@app/framework/dialog/scaffold-dialog.service';

@Component({
    selector: 'app-file-move-modal',
    templateUrl: './file-move-modal.component.html',
    styleUrls: [
        '../../rendered.component.scss',
        './file-move-modal.component.scss',
    ],
    standalone: false
})
export class FileMoveModalComponent implements OnInit {
  data: any = {};

  constructor(public dialogRef: ScaffoldDialogRef) {}

  ngOnInit() {
    console.log(this.data);
  }

  moveTo(folder) {
    this.dialogRef.close(folder);
  }
}
